export const FAILED_TO_CREATE_AUTH_CHALLENGE = 'Failed to create the authentication challenge.';
export const ACCEPT_USER_INVITATIONS = 'Invitation could not be accepted.';
export const DECLINE_USER_INVITATIONS = 'Invitation could not be declined.';
export const ERROR_UPLOADING_PROFILE_IMAGE = 'Error uploading profile image.';
export const ERROR_SAVING_PROFILE_IMAGE = 'Error saving profile image.';
export const ONLY_IMAGE_UPLOAD = 'You must upload a JPEG or PNG only.';
export const ADDRESS_NOT_FOUND = 'Address not found.';
export const DELETE_WORK_ORDER_COMMENT = 'Could not delete comment.';
export const UPDATE_WORK_ORDER_COMMENT = 'Could not update comment.';
export const DELETE_WORK_ORDER = 'Could not delete work order.';
export const FETCH_NOTIFICATIONS = 'Could not fetch notifications.';
export const UPDATE_USER_NOTIFICATION_SETTINGS = 'Could not update notification settings.';
export const UPDATE_ORGANIZATION_ACCOUNT = 'Could not update organization.';
export const DELETE_ORGANIZATION_ACCOUNT = 'Could not delete organization.';
export const UPDATE_USER = 'Could not update user.';
export const DELETE_USER = 'Could not delete user.';
export const CREATE_USER_INVITATIONS = 'Invitations could not be delivered.';
export const RESEND_USER_INVITATION = 'Invitation could not be resent.';
export const CANCEL_USER_INVITATION = 'Invitation could not be canceled.';
export const DELETE_USER_INVITATION = 'Invitation could not be discarded.';
export const UPDATE_USER_ROLE = 'Could not update user role.';
export const REMOVE_USER_FROM_ORGANIZATION = 'Cannot remove user from organization.';
export const UPDATE_PROPERTIES_ON_USER = 'Could not update properties on user.';
export const PROCURE_VENDOR_CREATE_ERROR = 'Could not create vendor.';
export const PROCURE_VENDOR_UPDATE_ERROR = 'Could not update vendor.';
export const DELETE_PROCURE_VENDOR_CONTACT =
  'There was an issue deleting the vendor contact person.';
export const UPDATE_PROCURE_VENDOR_CONTACT =
  'There was an issue updating the vendor contact person.';
export const DELETE_PROCURE_VENDOR = 'There was an issue deleting the vendor.';
export const PROCURE_VENDOR_CONTACT_CREATE =
  'There was an issue creating the vendor contact person.';
export const WEB_LINK_CREATE = 'There was a problem creating your web form link.';
export const PROPERTY_DELETE_ERROR = 'Error removing property.';
export const ATTACHMENT_REMOVE_ERROR = 'Failed to remove the attachment.';
export const UPLOAD_ATTACHMENT = 'Failed to upload the attachment.';
export const UPDATE_WORK_ORDER = 'Could not update work order.';
export const WARRANTY_PRODUCT_REQUEST = 'Could not submit warranty product request.';
